import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { geocodeDatasource } from '~src/geocoding/actions/GeocodeDatasourceAction';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { currentUserIsOwnerOrAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleNonEmbeddedDatasource } from './IEntityActionHelpers';

export const GeocodeDatasourceAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.GeocodeDatasource,
  translateName: Messages.geocodeDataSource,
  isVisible: (targetItems: IContentInfo[]) => {
    return isSingleNonEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: {}, targetItems: IContentInfo[]) => {
    const state = getAppStore().getState();
    return currentUserIsOwnerOrAdmin(state, targetItems[0]);
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }
    const item = targetItems[0];
    if (item.contentType === 'datasource') {
      return geocodeDatasource(item);
    }
  }
};
